import type { PeriodoEntregaFornecedorModel } from "../models/periodoEntregaFornecedorModel"
import type { PeriodoEntregaFornecedorActionModel } from "./periodoEntregaFornecedorActions"
import { PeriodoEntregaFornecedorActionsTypes } from "./periodoEntregaFornecedorActions"

export function periodoEntregaFornecedorReducer(
    state: PeriodoEntregaFornecedorModel,
    action: PeriodoEntregaFornecedorActionModel
): PeriodoEntregaFornecedorModel {
    switch (action.type) {
        case PeriodoEntregaFornecedorActionsTypes.CARREGAR:
            return {
                ...state,
                periodos: action.payload.periodos,
                statusDelivery: action.payload.statusDelivery,
            }

        case PeriodoEntregaFornecedorActionsTypes.ADICIONAR_PERIODO:
            return {
                ...state,
                periodos: [...state.periodos, action.payload],
            }

        case PeriodoEntregaFornecedorActionsTypes.ATUALIZAR_PERIODO:
            return {
                ...state,
                periodos: state.periodos.map(p =>
                    p.id === action.payload.id ? action.payload : p
                ),
            }

        case PeriodoEntregaFornecedorActionsTypes.REMOVER_PERIODO:
            return {
                ...state,
                periodos: state.periodos.filter(p => p.id !== action.payload),
            }

        case PeriodoEntregaFornecedorActionsTypes.ATUALIZAR_STATUS:
            return {
                ...state,
                statusDelivery: action.payload,
            }

        default:
            return state
    }
}
